import { RouteObject } from "react-router-dom";
import { bxBillCycleRoutes } from "./bill-cycle/routes";
import { billTemplateV2Routes } from "./billTemplateV2";
import { bulkBillGenerationRoutes } from "./bulk-bill-generation/routes";
import { dashboardRoutes } from "./dashboard";
import { bxGlRouteRoute } from "./gl-code/routes";
import { bxHistoryRoutes } from "./history";
import { bxPrintingDistributionRoutes } from "./printing-distribution";
import { bxSearchRoutes } from "./search";
import { bxSingleBillGenarationRoutes } from "./singleBillGenaration";
export interface BxRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: BxRoute[];
}
export const bxRoutes: BxRoute[] = [
  ...bulkBillGenerationRoutes,
  ...bxSingleBillGenarationRoutes,
  // ...bxBillTemplateRoutes,
  ...billTemplateV2Routes,
  ...bxSearchRoutes,
  ...dashboardRoutes,
  ...bxBillCycleRoutes,
  ...bxGlRouteRoute,
  ...bxPrintingDistributionRoutes,
  ...billTemplateV2Routes,
  ...bxHistoryRoutes,
];
